import React, { useState } from 'react';
// import ReactDOM from 'react-dom';
import { Formik, Field, Form } from 'formik';

export const Test = () => {
    const [checked, setChecked] = useState({ states: true })
    const handleStatus = (e, setFieldValue) => {
        let elementName = e.target.name;
        setChecked(!checked)
        // setChecked((prevState) => {
        //     const newState = { ...prevState };
        //     newState.elementName = !prevState.elementName;
            setFieldValue(elementName, !checked)
        //     return newState;
        // });
    }
    return (<div>
        <h1>Sign Up</h1>
        <Formik
            initialValues={{
                states: true,
            }}
            onSubmit={async (values) => {
                await new Promise((r) => setTimeout(r, 500));
                alert(JSON.stringify(values, null, 2));
            }}
        >
            {({ values, setFieldValue }) => (
                <Form>

                    <div id="my-radio-group">Picked</div>
                    <div role="group" aria-labelledby="my-radio-group">
                        <label>
                            <Field type="radio" name="states" value="One" checked={checked.states}
                                onChange={(e) => {
                                    handleStatus(e, setFieldValue)
                                }}
                            />
                            One
                        </label>
                        <label>
                            <Field type="radio" name="states" value="Two" checked={!checked.states}
                                onChange={(e) => {
                                    handleStatus(e, setFieldValue)
                                }}
                            />
                            Two
                        </label>
                        <div>Picked: {values.picked}</div>
                    </div>

                    <button type="submit">Submit</button>
                </Form>
            )}
        </Formik>
    </div>)
}

